import * as React from "react";
import Box from "@mui/material/Box";
import Table from "@mui/joy/Table";
import Typography from "@mui/joy/Typography";
import Sheet from "@mui/joy/Sheet";
import "../../css/inoutLive.css";
import { useState } from "react";
import { useEffect } from "react";

export default function InoutLiveSub({ data }) {
  const [inWt, setInWt] = useState();
  const [workWt, setWorkWt] = useState();
  const [outWt, setoutWt] = useState();
  useEffect(() => {
    setInWt(
      data
        .reduce((sum, item) => sum + (item.inWeight / 1000 || 0), 0)
        .toFixed(2)
    );

    setWorkWt(
      data
        .reduce(
          (acc, row) =>
            acc +
            row.eWorkList.reduce(
              (accWt, rows) => accWt + (rows.workWt / 1000 || 0),
              0
            ),
          0
        )
        .toFixed(2)
    );

    setoutWt(
      data
        .reduce(
          (acc, row) =>
            acc +
            row.eWorkList.reduce(
              (accWt, rows) => accWt + (rows.outWt / 1000 || 0),
              0
            ),
          0
        )
        .toFixed(2)
    );
  }, [data]);
  return (
    <Box sx={{ backgroundColor: "#f8f9fa", p: 0.5, m: 1 }}>
      <Box sx={{ height: 750 }}>
        {" "}
        <div>
          <Sheet sx={{ height: 750, overflow: "auto" }}>
            <Table
              aria-label="table with sticky header"
              stickyHeader
              stickyFooter
              stripe="odd"
              hoverRow
            >
              <thead>
                <tr>
                  <th>터미널</th>
                  <th>MAWB</th>
                  <th>입고중량</th>
                  <th>입고일시</th>
                  <th>ULD NO</th>
                  <th>작업중량</th>
                  <th>작업일시</th>
                  <th>BUP여부</th>
                  <th>출고중량</th>
                  <th>출고일시</th>
                  <th>오프로드일시</th>
                  <th>반출유형</th>
                </tr>
              </thead>
              <tbody>
                {data.map((row) => (
                  <React.Fragment key={row.id}>
                    <tr
                      key={row.id}
                      style={{
                        background: row.searchStatus === "U" ? "#FF0000" : "",
                      }}
                    >
                      <td
                        rowSpan={
                          row.eWorkList.length === 0 ? 1 : row.eWorkList.length
                        }
                      >
                        {row.terminalCode}
                      </td>
                      <td
                        rowSpan={
                          row.eWorkList.length === 0 ? 1 : row.eWorkList.length
                        }
                      >
                        {row.mawb}
                      </td>
                      <td
                        rowSpan={
                          row.eWorkList.length === 0 ? 1 : row.eWorkList.length
                        }
                      >
                        {row.inWeight}
                      </td>
                      <td
                        rowSpan={
                          row.eWorkList.length === 0 ? 1 : row.eWorkList.length
                        }
                      >
                        {row.inTime}
                      </td>
                      <td>
                        {row.eWorkList.length > 0 && (
                          <div>{row.eWorkList[0].uldNo}</div>
                        )}
                      </td>
                      <td>
                        {row.eWorkList.length > 0 && (
                          <div>{row.eWorkList[0].workWt}</div>
                        )}
                      </td>
                      <td>
                        {row.eWorkList.length > 0 && (
                          <div>{row.eWorkList[0].workDt}</div>
                        )}
                      </td>
                      <td>
                        {row.eWorkList.length > 0 && (
                          <div>{row.eWorkList[0].bupFlag}</div>
                        )}
                      </td>
                      <td>
                        {row.eWorkList.length > 0 && (
                          <div>{row.eWorkList[0].outWt}</div>
                        )}
                      </td>
                      <td>
                        {row.eWorkList.length > 0 && (
                          <div>{row.eWorkList[0].outDt}</div>
                        )}
                      </td>
                      <td>
                        {row.eWorkList.length > 0 && (
                          <div>{row.eWorkList[0].offDt}</div>
                        )}
                      </td>
                      <td>
                        {row.eWorkList.length > 0 && (
                          <div>{row.eWorkList[0].outKindName}</div>
                        )}
                      </td>
                    </tr>
                    {row.eWorkList.slice(1).map((rows) => (
                      <tr key={rows.uldId}>
                        <td>{rows.uldNo}</td>
                        <td>{rows.workWt}</td>
                        <td>{rows.workDt}</td>
                        <td>{rows.bupFlag}</td>
                        <td>{rows.outWt}</td>
                        <td>{rows.outDt}</td>
                        <td>{rows.offDt}</td>
                        <td>{rows.outKindName}</td>
                      </tr>
                    ))}
                  </React.Fragment>
                ))}
              </tbody>
              <tfoot>
                <tr>
                  <th scope="row">Totals</th>
                  <td></td>
                  <td>{inWt}Ton</td>
                  <td></td>
                  <td></td>
                  <td>{workWt}Ton</td>
                  <td></td>
                  <td></td>
                  <td>{outWt}Ton</td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
              </tfoot>
            </Table>
          </Sheet>
        </div>
      </Box>
    </Box>
  );
}
